module.exports = __WEBPACK_EXTERNAL_MODULE_156__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Rx","commonjs":"rxjs/add/operator/map","commonjs2":"rxjs/add/operator/map","amd":"rxjs/add/operator/map"}
// module id = 156
// module chunks = 0 1